// extracted by mini-css-extract-plugin
export default {"hyperlink":"EditorExtension_AlbumEmbed_hyperlink__dGf3O"};